/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AggregationLogDownloadResponse } from '../models/AggregationLogDownloadResponse';
import type { AggregationRegisterResponse } from '../models/AggregationRegisterResponse';
import type { BulkGrantAggregationRegisterForm } from '../models/BulkGrantAggregationRegisterForm';
import type { CampaignAggregationRegisterForm } from '../models/CampaignAggregationRegisterForm';
import type { PageAggregationLogIndexResponse } from '../models/PageAggregationLogIndexResponse';
import type { TransactionAggregationRegisterForm } from '../models/TransactionAggregationRegisterForm';
import type { UnusedBalanceAggregationForm } from '../models/UnusedBalanceAggregationForm';
import type { UnusedBalanceAggregationResponse } from '../models/UnusedBalanceAggregationResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AggregationRepository {

  /**
   * 集計履歴一覧表示
   * @returns PageAggregationLogIndexResponse OK
   * @throws ApiError
   */
  public static index({
    aggregationCategories,
    aggregatedAtStartDateTime,
    aggregatedAtEndDateTime,
    page = 1,
    size = 20,
    sort,
  }: {
    /**
     * 集計種別
     */
    aggregationCategories: Array<'TRANSACTION' | 'CAMPAIGN' | 'BULK_GRANT' | 'UNUSED_BALANCE'> | undefined,
    /**
     * 集計日時(開始日時)　※msまでの日時が検索に反映される
     */
    aggregatedAtStartDateTime: string | undefined,
    /**
     * 集計日時(終了日時)　※msまでの日時が検索に反映される
     */
    aggregatedAtEndDateTime: string | undefined,
    /**
     * One-based page index (1..N)
     */
    page: number | undefined,
    /**
     * The size of the page to be returned
     */
    size: number | undefined,
    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    sort: Array<string> | undefined,
  }): CancelablePromise<PageAggregationLogIndexResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/aggregation',
      query: {
        'aggregationCategories': aggregationCategories,
        'aggregatedAtStartDateTime': aggregatedAtStartDateTime,
        'aggregatedAtEndDateTime': aggregatedAtEndDateTime,
        'page': page,
        'size': size,
        'sort': sort,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 一括付与集計
   * @returns AggregationRegisterResponse OK
   * @throws ApiError
   */
  public static registerBulkGrantAggregation({
    requestBody,
  }: {
    requestBody: BulkGrantAggregationRegisterForm,
  }): CancelablePromise<AggregationRegisterResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/aggregation/bulk_grant',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * キャンペーン集計
   * @returns AggregationRegisterResponse OK
   * @throws ApiError
   */
  public static registerCampaignAggregation({
    requestBody,
  }: {
    requestBody: CampaignAggregationRegisterForm,
  }): CancelablePromise<AggregationRegisterResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/aggregation/campaign',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 取引集計
   * @returns AggregationRegisterResponse OK
   * @throws ApiError
   */
  public static registerTransactionAggregation({
    requestBody,
  }: {
    requestBody: TransactionAggregationRegisterForm,
  }): CancelablePromise<AggregationRegisterResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/aggregation/transaction',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 基準日未使用残高集計
   * @returns UnusedBalanceAggregationResponse OK
   * @throws ApiError
   */
  public static unusedBalanceAggregation({
    requestBody,
  }: {
    requestBody: UnusedBalanceAggregationForm,
  }): CancelablePromise<UnusedBalanceAggregationResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/aggregation/unused_balance',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 基準日未使用残高集計予約
   * @returns AggregationRegisterResponse OK
   * @throws ApiError
   */
  public static register({
    requestBody,
  }: {
    requestBody: UnusedBalanceAggregationForm,
  }): CancelablePromise<AggregationRegisterResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/aggregation/unused_balance/generate',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 集計csvをダウンロードするための署名付きURLを返却する
   * @returns AggregationLogDownloadResponse OK
   * @throws ApiError
   */
  public static downloadLog({
    id,
  }: {
    /**
     * 集計ID
     */
    id: string,
  }): CancelablePromise<AggregationLogDownloadResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/aggregation/{id}/download',
      path: {
        'id': id,
      },
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

}
